import { render } from "./aiWait.vue?vue&type=template&id=21e786ee&scoped=true"
import script from "./aiWait.vue?vue&type=script&lang=js"
export * from "./aiWait.vue?vue&type=script&lang=js"

import "./aiWait.vue?vue&type=style&index=0&id=21e786ee&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21e786ee"]])

export default __exports__